import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card mb-30" }
const _hoisted_4 = { class: "card-body pb-0" }
const _hoisted_5 = { class: "float-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-info" }, "新規追加", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "ユーザー管理", -1)
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table table-striped" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "メールアドレス"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "権限"),
    /*#__PURE__*/_createElementVNode("th", { class: "" })
  ])
], -1)
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = {
  key: 0,
  class: "m-1 badge badge-primary"
}
const _hoisted_15 = {
  key: 1,
  class: "m-1 badge badge-primary"
}
const _hoisted_16 = { class: "" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-success" }, "編集", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: {
                name: 'UserAdd',
              } }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    id: item.id
                  }, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.userName), 1),
                    _createElementVNode("td", _hoisted_13, [
                      (item.roleList.user)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "人事"))
                        : _createCommentVNode("", true),
                      (item.roleList.finance)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "経理"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        to: {
                        name: 'UserUpdate',
                        params: { id: item.id },
                      }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ], 8, _hoisted_11))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}